module.exports = __webpack_public_path__ + "img/Certificate.08ceac3c.jpg";